import { useState } from 'react'

import Tab from '@/components/view/atoms/tab/Tab'
import TabList from '@/components/view/atoms/tab/TabList'
import Content from '@/components/view/layouts/page/Content'
import Main, { MainLayoutType } from '@/components/view/layouts/page/Main'
import PageTitle from '@/components/view/molecules/title/PageTitle'

import ProductUnderstandingCoverageSection from './ProductUnderstandingCoverageSection'
import ProductUnderstandingListSection from './ProductUnderstandingListSection'
import ProductUnderstandingRunSection from './ProductUnderstandingRunSection'

// 商品意味理解（データ基盤 ＞ データ理解 ＞ 商品意味理解）。
// 4階層目（カバレッジ・分布／商品明細）はページ内タブで切り替える。カバレッジ・分布がデフォルト。
type PuTab = 'coverage' | 'list' | 'run'

const ProductUnderstandingPage = () => {
  const [tab, setTab] = useState<PuTab>('coverage')

  return (
    <Main type={MainLayoutType.FULL}>
      <PageTitle
        title='商品意味理解'
        description='商品情報からAIが抽出した構造化属性（8軸）で、商品の意味理解を可視化します。'
      />

      <Content>
        <div className='mt-3'>
          <TabList>
            <Tab selected={tab === 'coverage'} onClick={() => setTab('coverage')}>
              カバレッジ・分布
            </Tab>
            <Tab selected={tab === 'list'} onClick={() => setTab('list')}>
              商品明細
            </Tab>
            <Tab selected={tab === 'run'} onClick={() => setTab('run')}>
              実行
            </Tab>
          </TabList>
        </div>

        <div>
          {tab === 'coverage' ? (
            <ProductUnderstandingCoverageSection />
          ) : tab === 'list' ? (
            <ProductUnderstandingListSection />
          ) : (
            <ProductUnderstandingRunSection />
          )}
        </div>
      </Content>
    </Main>
  )
}

export default ProductUnderstandingPage
